import script from "./Login.vue?vue&type=script&setup=true&lang=ts"
export * from "./Login.vue?vue&type=script&setup=true&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=996220c8&scoped=true&lang=stylus"
script.__scopeId = "data-v-996220c8"

export default script